import Api from '../common/Api';
import {Backend, headers} from "../common/Config";
import Helpers from '../common/Helpers';

export default class Usuarios {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/usuario/create`,
            form,
            headers: headers
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/usuario/update`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async get(page = 0) {
        const response = await Api.get({
            url: `${Backend}/usuario/list/${page}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/usuario/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

}
